import { render, staticRenderFns } from "./FinalExamResultStudentView.vue?vue&type=template&id=45d71cac"
import script from "./FinalExamResultStudentView.vue?vue&type=script&lang=js"
export * from "./FinalExamResultStudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports